import Cookies, {getCookie} from './cookies';

// Retriver function for google analytics cookies
export function getClientId() {
  let clientId = null;

  const {analytics} = Cookies.consent || {};
  if (!analytics) return null;

  const gaCookie = getCookie('_ga');
  if (gaCookie) {
    // Format: _ga=GA1.2.XXXXXXXXXX.YYYYYYYYYY
    const parts = gaCookie.split('.');
    if (parts.length >= 4) {
      // Client ID is the last two parts joined
      clientId = `${parts[2]}.${parts[3]}`;
    }
  }

  return clientId;
}

// Retriver function for google ads cookies: Specifically for redirection coming from web
export function getGCLIdAdWords() {
  // let gclid = null;

  const {marketing} = Cookies.consent || {};
  if (!marketing) return null;

  const gclCookie = getCookie('_gcl_aw');
  // if (gclCookie) {
  //   // Format: _gcl_aw=GCL.TIMESTAMP.GCLID
  //   const parts = gclCookie.split('.');
  //   if (parts.length >= 3) {
  //     gclid = parts[2];
  //   }
  // }

  return gclCookie;
}

// Retriver function for google ads cookies: Specifically for redirection coming from mobile or any application
export function getGCLIdAutoTaggingUniversal() {
  // let gclid = null;

  const {marketing} = Cookies.consent || {};
  if (!marketing) return null;

  const gclCookie = getCookie('_gcl_au');
  // if (gclCookie) {
  //   // Format: _gcl_au=VERSION.INTERNAL_COUNTER.GCLID.TIMESTAMP.
  //   const parts = gclCookie.split('.');
  //   if (parts.length >= 4) {
  //     gclid = parts[2];
  //   }
  // }

  return gclCookie;
}
